import { render } from "./LoaderList.vue?vue&type=template&id=af044828"
import script from "./LoaderList.vue?vue&type=script&lang=js"
export * from "./LoaderList.vue?vue&type=script&lang=js"

import "./LoaderList.vue?vue&type=style&index=0&id=af044828&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__